const clean = value => typeof value === "string" && value.trim() ? value.trim() : null;
const internalId = value => /^(?:[0-9a-f]{8}-[0-9a-f-]{27,}|[0-9a-f]{24}|(?:site|block|flat|room)_[0-9a-z-]{8,})$/i.test(value || "");
const friendly = (value, fallback) => {
  const next = clean(value);
  return next && !internalId(next) ? next : fallback;
};

/** Canonical Site -> Block -> Flat -> Room property hierarchy. */
export function locationParts(location = {}) {
  const hasLocation = ["site_name","siteName","site_id","block_name","blockName","block_id","flat_name","flatName","flat_id","room_name","roomName","room_id"].some(key => clean(location[key]));
  if (!hasLocation) return [];
  return [
    friendly(location.site_name || location.siteName, "Unknown Site"),
    friendly(location.block_name || location.blockName, null),
    friendly(location.flat_name || location.flatName, null),
    friendly(location.room_name || location.roomName || location.name, location.room_id ? "Unknown Room" : null),
  ].filter(Boolean);
}

export function formatLocation(location, separator = " · ") {
  return locationParts(location).join(separator);
}

export const formatLocationHierarchy = location => formatLocation(location, " → ");

/** Operational list grouping: Flat + Room primary; Site + Block context. */
export function repairLocation(location = {}) {
  const site = friendly(location.site_name, location.site_id ? "Unknown Site" : null), block = friendly(location.block_name, null);
  const flat = friendly(location.flat_name, null), room = friendly(location.room_name, location.room_id ? "Unknown Room" : null);
  if (flat || room) return {
    primary: [flat, room].filter(Boolean).join(" · "),
    secondary: [site, block].filter(Boolean).join(" · "),
  };
  if (block) return { primary: block, secondary: site || "" };
  return { primary: site || "Location not recorded", secondary: "" };
}
